import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-cms-page',
  templateUrl: './cms-page.component.html',
  styleUrls: ['./cms-page.component.scss']
})
export class CmsPageComponent implements OnInit {
  title = '';
  safeHtmlContent: SafeHtml;
  unSubCribe: Subscription;
  CtPage = 'default';
  faqList = [];
  panelOpenState = {};
  constructor(private apiService: ApiService, private sanitizer: DomSanitizer, private activate: ActivatedRoute,
    public router:Router, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    const currentRoute = this.router.url;
    let url = currentRoute.split('/')[1];
    this.CtPage = url;
    this.GetCMSPages(url);
  }

  GetCMSPages(name) {
    this.apiService.setLoader(true);
    let storeId = JSON.parse(sessionStorage.getItem('store')).id;
    this.apiService.getContentItems({type: 'pages', store_id:storeId, item_handle:name}).subscribe(result => {
      if (result['response']['status'] === 1) {
        this.apiService.SetCmsPage(result['response']['data']);
        if (result['response']['data'].length > 0) {
          const Htmlcontent = result['response']['data'][0]['content'];
          this.safeHtmlContent = Htmlcontent;
        }
      }
     });
  }
} 
